<script>
    import { initSelect2 } from "../../libs/select2facets";
    import { query } from "../../libs/stores";

    $: sortBy = $query.sort || { field: '', order: ''};
</script>
<select on:filterSelected on:filterUnselected class="c-facets__select" name="ordina" use:initSelect2={sortBy && 'Rilevanza'}>
    <option></option>
    <option value="date_start_dt:asc"  selected={sortBy.field === 'date_start_dt' && sortBy.order === 'asc'}>Data ascendente</option>
    <option value="date_start_dt:desc" selected={sortBy.field === 'date_start_dt' && sortBy.order === 'desc'}>Data discendente</option>
    <option value="title_s:asc"        selected={sortBy.field === 'title_s' && sortBy.order === 'asc'}>Alfabeto ascendente</option>
    <option value="title_s:desc"       selected={sortBy.field === 'title_s' && sortBy.order === 'desc'}>Alfabeto discendente</option>
</select>
